const getUserAudiencesQuery = /* GraphQL */ `
  query GetUserAudiences($webUserGuid: String) {
    userAudiencesV2(webUserGuid: $webUserGuid) {
      audiences
      googleAudiences
    }
  }
`

export default getUserAudiencesQuery
